module.exports = __webpack_public_path__ + "static/fonts/GroteskDemiRegular.cc8e2cb.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/GroteskDemiRegular.ttf
// module id = Qbef
// module chunks = 0